
import { useContext } from "react";
import { AppContext } from "../contexts/App";
import { CENSORED } from "../constants/generic";

export default function Censor({ data }: { data: string }) {
    const { eye } = useContext(AppContext)
    return <>{(eye === 'close' ? CENSORED : data)}</>
}
